namespace SP {
    export interface AuditZoneInfo {
        id: string;
        name: string;
        dirtyCount: number;
        placementDatas: string[];
    }
}